<template>
  <div class="data-title-group"
       :class="{'is-bold': bold, 'is-fold': fold}">
    <div class="header">
      <div class="title" :class="{'line': line, 'dash-line': dashLine}">
        <div v-if="bar"
             class="bar theme-bg"></div>
        <slot name="title">
          <span>{{title}}</span>
        </slot>
      </div>
      <div class="extra">
        <template v-if="fold">
          <el-button size="mini"
                     type="text"
                     @click="toggleFold">
            <i :class="['el-icon-caret-top', {'fold': isFold}]"></i>
            <span>{{isFold ? '展开' : '折叠'}}</span>
          </el-button>
        </template>
        <template v-else>
          <slot name="extra"></slot>
        </template>
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="!isFold"
           class="main">
        <template v-if="editMode && $slots.edit">
          <slot name="edit"></slot>
        </template>
        <template v-else>
          <slot></slot>
        </template>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'DataTitleGroup',
  props: {
    title: String,
    editMode: false,
    bar: {
      type: Boolean,
      default: true
    },
    line: Boolean,
    dashLine: Boolean,
    bold: {
      type: Boolean,
      default: true
    },
    fold: Boolean
  },
  data () {
    return {
      isFold: false
    }
  },
  methods: {
    toggleFold () {
      this.isFold = !this.isFold
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-title-group {
    &.is-bold {
      &>.header {
        &>.title {
          font-weight: 500;
        }
      }
    }
    &.is-fold {
      &>.header {
        background-color: #f5f7fa;
        border-bottom: 1px solid #ebeef5;
        &>.title {
          display: flex;
          align-items: center;
        }
        &>.extra {
          .el-button {
            color: #909399;
            font-size: 12px;
            padding: 0;
            i {
              transition: transform .3s;
              font-size: 12px;
              &.fold {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
      &>.main {
        padding: 0;
      }
    }
    &>.header {
      padding: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &>.title {
        flex: auto;
        position: relative;
        padding-left: 10px;
        color: #303133;
        font-size: 13px;
        &>.bar {
          position: absolute;
          left: 0;
          top: 50%;
          width: 3px;
          height: 11px;
          margin-top: -5px;
        }
        i {
          margin-right: 5px;
          margin-top: 2px;
          font-size: 14px;
        }
        &.line,
        &.dash-line {
          display: flex;
          align-items: center;
          &:after {
            content: '';
            flex: auto;
            height: 1px;
            background-color: #ebeef5;
            margin-left: 12px;
          }
        }
        &.dash-line {
          &:after {
            background: linear-gradient(to right, #dcdfe6 0%, #dcdfe6 70%, transparent 70%) repeat-x!important;
            background-size: 12px 1px!important;
          }
        }
      }
      &>.extra {
        flex: none;
      }
    }
  }
</style>
